<template lang="pug">
.fillblank
  Form(:model="question" label-position="right")
    .question-stem
      Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
        @click='showAIDialog()',v-if='enableAI') AI生成
      Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
        Form(:model="aiForm" :label-width="80")
          FormItem(label="生成数量")
            InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
          FormItem(label='提示词',prop="stem")
            Input(v-model='aiForm.system' placeholder='请填写提示词'
              type="textarea" :rows="3")
      FormItem
        //- span(style="float:left;width:20px; height:32px; line-height:32px;font-size:14px") 3.
        Input(placeholder="题目内容",v-model='question.stem')
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    FormItem(v-show="isEditTips")
      Input(placeholder="编辑提示信息",v-model="question.tips").case-title
    FormItem(label='参考答案' :label-width="80")
      iTag(:tag-data='question.metas')
    div.checkbox
      Checkbox(v-model="question.isShow" style="float:left" @on-change="changebox") 显示答案
    FormItem(label='答案解析' :label-width="80")
            textarea.explain(v-model='question.analysis' placeholder="")
    FormItem(label='评分关键词' :label-width="80")
      iTag(:tag-data='question.scoringKeywords')
    FormItem(label='分值' :label-width="80")
       InputNumber(v-model.sync="question.score",
        :min="0" :max="10",
        style="float:left",
        :disabled="question.isShow")
    .question-edit
      isEditTips(:is-edit='isEditTips' :event='editTips')
</template>

<script>
import iTag from "@/components/common/iTag";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import Bus from "../../utils/bus";
export default {
  components: {
    iTag,
    iDelModel,
    isEditTips
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      tipBtnType: "编辑",
      isEditTips: false,
      question: {
        stem: "",
        tips: "",
        isShow: false,
        metas: [],
        scoringKeywords: [],
        analysis: "",
        score: 0
      },
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "GAPFILLING",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    // 复选框状态
    changebox() {
      this.question.score = 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // this.$emit("data1:data", this.question);
    //   this.$nextTick(() => {
    //     this.from = this.parent.Case.basic;
    //   });
  }
};
</script>
<style lang="stylus">
.fillblank
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .checkbox
    width 100%
    height 50px
    padding-left 85px
  .explain
    width 100%
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    resize none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    padding 5px
</style>
